import { usePartnerProgram } from '../composables/usePartnerProgram'

export default defineNuxtPlugin(() => {
  const { visitByPartner, saveUtmCookies } = usePartnerProgram()

  visitByPartner()
  saveUtmCookies()
})
